import { Pipe, PipeTransform } from '@angular/core';
import { ActorType } from '../../shared/datamodel';

import { LssEntity } from '../../configuration/store/lss-entity.datamodel';

/**
 * Pipe to filter the children of an entity to only return the children that are of type OGU.
 */
@Pipe({
    name: 'childrenOgus',
    standalone: false
})
export class ChildrenOgusPipe implements PipeTransform {

  transform<E extends LssEntity<E>>(entity: E): E[] {
    return entity.childrenTree.filter((child: E) =>
      child.actor.actorType === ActorType.OGU_ORGANISATION);
  }
}
